import { render, staticRenderFns } from "./ReportMains.vue?vue&type=template&id=2e165c7a&scoped=true&"
import script from "./ReportMains.vue?vue&type=script&lang=js&"
export * from "./ReportMains.vue?vue&type=script&lang=js&"
import style0 from "./ReportMains.vue?vue&type=style&index=0&id=2e165c7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e165c7a",
  null
  
)

export default component.exports